import React from 'react'
import './search_form.scss'
import { loadPikadayIfNeeded } from "../../top/index/pikaday_loader"
import { countryPrefectureNames } from '../../common/constants/prefectures'

const PREFECTURES = countryPrefectureNames()

class SearchForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      prefecture: 'tokyo'
    }
  }

  componentDidMount() {
    loadPikadayIfNeeded()
  }

  addDays(date, days) {
    const daysInSeconds = days * 24 * 60 * 60 * 1000
    return new Date(date.getTime() + daysInSeconds)
  }

  ymd(date) {
    const y = date.getFullYear()
    const m = ('0' + (date.getMonth() + 1)).slice(-2)
    const d = ('0' + date.getDate()).slice(-2)
    return `${y}-${m}-${d}`
  }

  get minCheckin() {
    return new Date()
  }

  get minCheckout() {
    return this.addDays(this.minCheckin, 1)
  }

  get maxCheckin() {
    return this.addDays(this.minCheckin, 365 * 2)
  }

  get maxCheckout() {
    return this.addDays(this.minCheckout, 365 * 2)
  }

  render() {
    return (
      <div id="search-form" styleName="search-form-container">
        <form
          action={`/s/${this.state.prefecture}`}
          styleName="search-form "
          className="js-search-form"
          method="get"
          name="searchForm"
          data-bound="true">
          <div styleName="search-form-input-group">
            <div styleName="select-area">
              <label styleName="select-guests-label" htmlFor="prefecture-select">エリア</label>
              <div styleName="select-guests-wrap">
                <select
                  id="prefecture-select"
                  aria-label="エリア"
                  styleName="adults-select"
                  onChange={ e => this.setState({prefecture: e.target.value})}
                  defaultValue="tokyo" >
                  {Object.keys(PREFECTURES).map((roman, index) => (
                    <option key={index} value={roman}>{PREFECTURES[roman]}</option>
                  ))}
                </select>
              </div>
            </div>

            <div styleName="date-range-container">
              <div styleName="date-range-input-container" className="js-date-range-input-container">
                <label styleName="date-range-label" htmlFor="checkin">チェックイン</label>
                <input aria-label="チェックイン"
                  styleName="date-range-input" className="js-date-range-input"
                  id="checkin" max={this.ymd(this.maxCheckin)}
                  min={this.ymd(this.minCheckin)} name="checkin"
                  placeholder="指定なし" type="date"
                  autoComplete="off" />
              </div>
              <div styleName="date-range-input-container" className="js-date-range-input-container">
                <label styleName="date-range-label" htmlFor="checkout">チェックアウト</label>
                <input aria-label="チェックアウト"
                  styleName="date-range-input"
                  className="js-date-range-input"
                  id="checkout" max={this.ymd(this.maxCheckout)}
                  min={this.ymd(this.minCheckout)} name="checkout"
                  placeholder="指定なし" type="date"
                  autoComplete="off" />
              </div>
              <div styleName="pikaday-container" className="js-pikaday-container">
              </div>
            </div>

            <div styleName="select-guests">
              <label styleName="select-guests-label" htmlFor="adults">人数（2歳以上）</label>
              <div styleName="select-guests-wrap">
                <select aria-label="人数（2歳以上）" styleName="adults-select" id="adults" name="adults">
                  { Array.from(Array(15)).map((_, i) =>
                    <option key={i} value={ i > 0 ? i + 1 : '' }>
                      { i + 1 }名
                    </option>)}
                </select>
              </div>
            </div>

            <div styleName="submit-btn">
              <button styleName="btn-primary" className="extended" type="submit">
                <span className="vs-icon-search"></span>
                <span styleName="btn-label">検索</span>
              </button>
            </div>
            <input name="property_types" type="hidden" value="apartment" />
            <input name="property_types" type="hidden" value="house" />
            <input name="disinfection_measure_codes" type="hidden" value="ANY" />
            <input name="amenities" type="hidden" value="kitchen" />
            <input name="amenities" type="hidden" value="refrigerator" />
            <input name="amenities" type="hidden" value="micro_wave_oven" />
            <input name="amenities" type="hidden" value="dryer" />
            <input name="amenities" type="hidden" value="wifi" />
            <input name="amenities" type="hidden" value="washer" />
            <input name="amenities" type="hidden" value="working_desk" />
          </div>

        </form>
      </div>

    )
  }
}

export default SearchForm
